import { Checkbox, DatePicker, Form, Input, InputNumber, Modal } from "antd";
import moment from "moment";
import { useEffect } from "react";
import SingleUpload from "./SingleUpload";

interface ModalAddSubscriptionProps {
  visible: boolean;
  confirmLoading?: boolean;
  handleClose: (values?: Record<string, any>) => void;
}

const ModalAddSubscription: React.FC<ModalAddSubscriptionProps> = ({
  visible,
  confirmLoading,
  handleClose,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible]);

  const onFinish = (values: Record<string, any>) => {
    handleClose(values);
  };

  return (
    <Modal
      title="Add Subscription"
      open={visible}
      confirmLoading={confirmLoading}
      onCancel={() => handleClose()}
      okText={"Add"}
      onOk={form.submit}
    >
      <Form
        form={form}
        className="ant-advanced-search-form"
        onFinish={onFinish}
        layout="vertical"
      >
        <Form.Item
          name="start_date"
          label="Start Date"
          rules={[
            {
              required: true,
              message: "Select Start Date",
            },
          ]}
          getValueProps={(value) => ({
            value: value ? moment(value, "YYYY-MM-DD") : null,
          })}
          getValueFromEvent={(value) => value && value.format("YYYY-MM-DD")}
        >
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          name="end_date"
          label="End Date"
          getValueProps={(value) => ({
            value: value ? moment(value, "YYYY-MM-DD") : null,
          })}
          getValueFromEvent={(value) => value && value.format("YYYY-MM-DD")}
          rules={[
            {
              required: true,
              message: "Select End Date",
            },
          ]}
        >
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          name="amount"
          label="Amount"
          rules={[
            {
              required: true,
              message: "Enter amount",
            },
          ]}
        >
          <InputNumber style={{ width: "100%" }} placeholder="amount" />
        </Form.Item>

        <Form.Item name="remark" label="Remark">
          <Input.TextArea style={{ width: "100%" }} placeholder="remark" />
        </Form.Item>
        <div style={{ display: "flex" }}>
          <Form.Item
            name="payment_receipt"
            label="Payment receipt"
            style={{ flex: 1 }}
          >
            <SingleUpload />
          </Form.Item>
          <Form.Item
            name="is_manual_paid"
            valuePropName="checked"
            style={{ flex: 1 }}
          >
            <Checkbox>Manually paid</Checkbox>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalAddSubscription;
